module.exports = __webpack_public_path__ + "static/media/OCA logo and tagline.5f987d9a.png";